import { Container, Typography, Box, Grid, Card, CardContent, CardMedia, CardActions, Button, Chip, Avatar } from '@mui/material'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import PersonIcon from '@mui/icons-material/Person'

const blogPosts = [
  {
    id: 1,
    title: 'The Future of Solar Energy in 2024',
    excerpt: 'Explore the latest trends in solar technology, from higher efficiency panels to smart battery storage solutions that are revolutionizing the industry.',
    author: 'Admin Team',
    date: 'Jan 15, 2025',
    category: 'Technology',
    image: 'https://images.unsplash.com/photo-1548337138-e87d889cc369?q=80&w=600&auto=format&fit=crop'
  },
  {
    id: 2,
    title: 'How to Maintain Your Solar Panels',
    excerpt: 'Simple maintenance tips to keep your solar system running at peak performance. Learn when to clean your panels and how to spot potential issues early.',
    author: 'Tech Expert',
    date: 'Dec 28, 2024',
    category: 'Maintenance',
    image: 'https://images.unsplash.com/photo-1613665813446-82a78c468a1d?q=80&w=600&auto=format&fit=crop'
  },
  {
    id: 3,
    title: 'Calculating Your Solar ROI',
    excerpt: 'Understanding the financial benefits of switching to solar. We break down the costs, savings, and long-term return on investment for homeowners.',
    author: 'Finance Guru',
    date: 'Dec 10, 2024',
    category: 'Finance',
    image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?q=80&w=600&auto=format&fit=crop'
  },
  {
    id: 4,
    title: 'Hybrid vs On-Grid Inverters',
    excerpt: 'What is the difference between hybrid and on-grid inverters? We compare the pros and cons to help you choose the right system for your home.',
    author: 'Admin Team',
    date: 'Nov 22, 2024',
    category: 'Products',
    image: 'https://images.unsplash.com/photo-1558449028-b53a39d100fc?w=600&auto=format&fit=crop&q=60'
  },
  {
    id: 5,
    title: 'Benefits of Lithium Batteries',
    excerpt: 'Why lithium-ion batteries are becoming the standard for solar storage. Longer lifespan, faster charging, and better efficiency explained.',
    author: 'Tech Expert',
    date: 'Oct 30, 2024',
    category: 'Technology',
    image: 'https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=600&auto=format&fit=crop&q=60'
  }
]

export default function BlogsPage() {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold" color="primary">
          Solar Insights
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
          Stay updated with the latest news, tips, and trends in the world of solar energy.
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {blogPosts.map((post) => (
          <Grid item xs={12} md={post.id === 1 ? 12 : 6} key={post.id}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: post.id === 1 ? { xs: 'column', md: 'row' } : 'column', transition: '0.3s', '&:hover': { transform: 'translateY(-5px)', boxShadow: 6 } }}>
              <CardMedia
                component="img"
                image={post.image}
                alt={post.title}
                sx={{
                  width: post.id === 1 ? { xs: '100%', md: '50%' } : '100%',
                  height: post.id === 1 ? { xs: 300, md: 'auto' } : 240
                }}
              />
              <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 3 }}>
                <Box sx={{ mb: 2 }}>
                  <Chip label={post.category} color="primary" size="small" variant="outlined" />
                </Box>
                <Typography gutterBottom variant={post.id === 1 ? "h4" : "h5"} component="h2" fontWeight="bold">
                  {post.title}
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph>
                  {post.excerpt}
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', mt: 'auto', pt: 2 }}>
                  <Avatar sx={{ width: 32, height: 32, mr: 1, bgcolor: 'secondary.main' }}>
                    <PersonIcon fontSize="small" />
                  </Avatar>
                  <Typography variant="caption" color="text.secondary" sx={{ mr: 2 }}>
                    {post.author}
                  </Typography>
                  <CalendarTodayIcon sx={{ fontSize: 16, color: 'text.secondary', mr: 0.5 }} />
                  <Typography variant="caption" color="text.secondary">
                    {post.date}
                  </Typography>
                </Box>

                <CardActions sx={{ px: 0, pt: 2 }}>
                  <Button size="small" color="primary" sx={{ fontWeight: 'bold' }}>Read More</Button>
                </CardActions>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  )
}